export default "__VITE_ASSET__Du2yxt6___"